
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderShippingItemsReportDialog extends Serenity.EntityDialog<OrderShippingItemsReportRow, any> {
        protected getFormKey() { return OrderShippingItemsReportForm.formKey; }
        protected getIdProperty() { return OrderShippingItemsReportRow.idProperty; }
        protected getLocalTextPrefix() { return OrderShippingItemsReportRow.localTextPrefix; }
        protected getNameProperty() { return OrderShippingItemsReportRow.nameProperty; }
        protected getService() { return OrderShippingItemsReportService.baseUrl; }
        protected getDeletePermission() { return OrderShippingItemsReportRow.deletePermission; }
        protected getInsertPermission() { return OrderShippingItemsReportRow.insertPermission; }
        protected getUpdatePermission() { return OrderShippingItemsReportRow.updatePermission; }

        protected form = new OrderShippingItemsReportForm(this.idPrefix);

    }
}